import { mdiMapMarker } from '@mdi/js'
import Icon from '@mdi/react'
import React from 'react'
import i18n from '../../utilities/i18n'

const MapMarker = (props) => (
    <Icon
        data-testid="IconButton__MapMarkerButton"
        title={i18n.t('modelTile.location')}
        path={mdiMapMarker}
        size={1}
        {...props}
    />
)

export default React.memo(MapMarker)
